import { defineStore, getActivePinia, } from 'pinia'
import fetch from '@/assets/js/src/util/fetch'
import { getDefaultHeaders, } from '@/assets/js/src/util/fetch/defaultHeaders'
import { checkResponse, handleException, } from '@/assets/js/src/util/apiTools'
import { useLangStore, } from '@/assets/js/src/modules/lang/_pinia/lang'

const API_GET_ONE_HELPITEM = '/api/help/'
const API_SEND_HIT = '/api/help/hit'
const API_SEND_VOTING = '/api/help/voting'

export const useHelpItemStore = defineStore('helpItem', {
    state: () => ({
        helpItem: {},
        children: [],
    }),
    actions: {
        async sendVoting ({ id, item, message, vote, }) {
            try {
                let withId = id !== 0
                let apiResponse = await fetch({
                    url: `${API_SEND_VOTING}${withId ? '/' + id : ''}`,
                    options: {
                        method: withId ? 'PATCH' : 'POST',
                        body: JSON.stringify({ item: item, message: message, vote: vote, }),
                        headers: getDefaultHeaders({}),
                    },
                })

                // Api-Response prüfen
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                return apiResponse.data
            } catch (e) {
                // Evtl. Fehler ausgeben
                handleException(e, true, true)

                return false
            }
        },
        
        async sendHit ({ id, }) {
            try {
                await fetch({
                    url: `${API_SEND_HIT}`,
                    options: {
                        method: 'PATCH',
                        body: JSON.stringify({ id, }),
                        headers: {
                            'x-silent-request': true,
                            ...getDefaultHeaders({}),
                        },
                    },
                    loading: false,
                })
            } catch (e) {
                // Evtl. Fehler ausgeben
                handleException(e, false, false)
            }
        },
        
        async getHelpItem ({ id, }) {
            let activePinia = getActivePinia()
            let langStore = useLangStore(activePinia)
            try {
                // Api-Request senden
                let useCache = true
                let apiResponse = await fetch({
                    url: `${API_GET_ONE_HELPITEM}${id}`,
                    options: {
                        headers: getDefaultHeaders({
                            useCache,
                        }),
                    },
                    useCache,
                    includeTagsInId: true,
                    tags: [
                        'help',
                        `locale.${langStore.locale}`,
                    ],
                })

                // Api-Response prüfen
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                this.children = apiResponse.data.children || []
                this.helpItem = apiResponse.data
            } catch (e) {
                // Evtl. Fehler ausgeben
                handleException(e, true, true)
            }
        },
    },
})
